import { action, computed, observable } from "mobx";

export class StoreStatus {
  @observable
  error: Error | undefined;

  @computed
  get hasError(): boolean {
    return this.error !== undefined;
  }
  @action
  setError = (message: string, error?: Error) => {
    this.error = new Error(message);
    if (error) console.error(error);
  };
  @action
  clearError = () => {
    this.error = undefined;
  };
}



// WEBPACK FOOTER //
// ./app/stores/_models/storeStatus.ts